<!-- 结算单审批申请 -->
<template>
    <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
        <!-- start of title -->
        <div class="title-box">
            <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
            <span>结算单审批申请</span>
        </div>
        <!-- end of title -->

        <!-- start of form -->
        <div class="form-box">
            <!-- start of 结算单信息 -->
            <div class="back-color-fff mt-4">
                <span class="form-title">结算单信息</span>

                <el-form :model="formData" ref="formData">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="关联流程" prop="relevance" label-width="145px">
                                <span slot="label">
                                    <span style="color: red">*</span>关联质量考核：
                                </span>
                                <el-input v-model="formData.relevance" placeholder="请选择关联质量考核" readonly
                                    @focus="focusRelevance" style="width:330px;">
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="关联流程" prop="relevance" label-width="145px">
                                <span slot="label">
                                    <span style="color: red">*</span>关联服务商：
                                </span>
                                <el-select size="small" v-model="formData.servicerGuid" placeholder="请选择企业"
                                    style="width:330px;" @change="tenantChange" filterable>
                                    <el-option v-for="item in serviceTenantList" :key="item.guid"
                                        :label="item.tenantName" :value="item.guid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>


                        <el-col :span="12">
                            <el-form-item label="结算日期" prop="settleDate" label-width="145px">
                                <span slot="label">
                                    <span style="color: red">*</span>结算日期<el-tooltip class="item" effect="dark"
                                        content="结算日期为支付给平台服务人员的时间" placement="right-start"><i
                                            class="el-icon-question"></i></el-tooltip>：
                                </span>
                                <el-date-picker style="width:330px;" @change="changeSettleDate" :picker-options="pickerOptions"
                                    v-model="formData.settleDate" type="date" placeholder="选择结算日期" format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="申请盖章" prop="isStampApply" label-width="145px">
                                <span slot="label">
                                    <span style="color: red">*</span>申请盖章：
                                </span>
                                <el-select style="width:330px;" filterable clearable v-model="formData.isStampApply" placeholder="请选择申请盖章">
                                    <el-option label="是" value="Y"></el-option>
                                    <el-option label="否" value="N"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="!haveHedge">
                            <el-form-item label="关联金额对冲流程" label-width="145px">
                                <span slot="label">
                                    关联金额对冲流程：
                                </span>
                                <el-input v-model="formData.relevanceHedge" placeholder="请选择关联金额对冲流程" readonly
                                    @focus="showHedgeList" style="width:330px;">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- end of 结算单信息 -->

            <!-- start of 单据明细 -->
            <div class="back-color-fff mt-4 pd-16">
                <span class="form-title">单据明细</span>
                <div class="content-main-box detail-box">
                    <div class="flex-between" v-if="tableData && tableData.length > 0">
                        <div class="button-area" style="margin-top:-8px;">
                            <el-button
                                size="mini" type="info" 
                                @click="batchEdit()"
                            >
                                批量修改供应商
                            </el-button>
                            <el-button size="mini" type="info" @click="batchEditTime()">批量修改结算日期</el-button>
                            <el-button size="mini" type="info" @click="getOrganisation()">批量删除</el-button>
                        </div>
                        <p class="total-tip">结算金额合计：<span>{{ getSumAmount(tableData, 1) |
                                numDigit }}</span>元&nbsp;&nbsp;&nbsp;应发金额合计：<span>{{ getSumAmount(tableData, 2)
                                | numDigit }}</span> 元&nbsp;&nbsp;&nbsp;实发金额合计：<span>{{ getSumAmount(tableData, 3) |
                                numDigit }}</span> 元</p>
                    </div>
                    <el-table stripe border ref="multipleTable" max-height="352px" :data="tableData"
                        :row-key="(row) => row.rowKey" @selection-change="handleSelectionChange">
                        <!-- selection -->
                        <el-table-column type="selection" width="60" header-align="center"
                            align="center"></el-table-column>
                        <!-- 序号 -->
                        <el-table-column label="序号" width="60" header-align="center" align="center">
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{ scope.$index + 1
                                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- 姓名 -->
                        <el-table-column width="96" prop="staffName" label="姓名" header-align="center" align="left"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{ scope.row.staffName ||
                                    '-'
                                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- 身份证号 -->
                        <el-table-column prop="idCode" label="身份证号" header-align="center" align="left"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{ scope.row.idCode || '-'
                                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- 银行卡号 -->
                        <el-table-column prop="bankAccount" label="银行卡号" header-align="center" align="left"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{ scope.row.bankAccount ||
                                    '-'
                                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- 手机号 -->
                        <el-table-column prop="mobileNo" label="手机号" header-align="center" align="left"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{ scope.row.mobileNo || '-'
                                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- 任务内容 -->
                        <el-table-column prop="taskContent" label="任务内容" header-align="center" align="left"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''"> {{ scope.row.taskContent ||
                                    '-'
                                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- 结算金额 -->
                        <el-table-column prop="settleAmount" width="100" label="结算金额(元)" header-align="center"
                            align="right">
                            <template slot-scope="scope"><span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                                    scope.row.settleAmount | numFmt | numDigit }}</span></template>
                        </el-table-column>
                        <!-- 本月累计下发金额 -->
                        <el-table-column prop="currentMonthMoneySum" width="140" label="本月累计下发金额(元)"
                            header-align="center" align="right" show-overflow-tooltip>
                            <template slot-scope="scope"><span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                                    scope.row.currentMonthMoneySum | numFmt | numDigit }}</span></template>
                        </el-table-column>
                        <!-- 已发金额（新加） -->
                        <el-table-column prop="lastMonthMoney" min-width="96" label=" 已发金额(元)" header-align="center"
                            align="right" show-overflow-tooltip>
                            <template slot-scope="scope"><span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{
                                    scope.row.paidMoney | numFmt | numDigit }}</span></template>
                        </el-table-column>
                        <!-- 未发金额 -->
                        <el-table-column prop="lastMonthMoney" min-width="96" label="未发金额(元)" header-align="center"
                            align="right" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''"> {{ scope.row.unPayMoney |
                                    numFmt |
                                    numDigit }}</span>
                            </template>
                        </el-table-column>
                        <!-- 应发金额（新加） -->
                        <el-table-column prop="lastMonthMoney" min-width="96" label="应发金额(元)" header-align="center"
                            align="right" show-overflow-tooltip>
                            <template slot-scope="scope"> <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">
                                    {{
                                    scope.row.realSettleMoney | numFmt | numDigit }}</span></template>
                        </el-table-column>
                        <!-- 实发金额（新加） -->
                        <el-table-column prop="lastMonthMoney" width="150" label="实发金额(元)" header-align="center"
                            align="right">
                            <template slot-scope="scope">
                                <!-- <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''"> {{scope.row.realSettleMoney | numFmt | numDigit }} </span>-->
                                <!-- <el-input-number size="mini"  :precision="2" :controls="false" placeholder="请输入" v-model.trim="scope.row.realSettleMoney">
                                </el-input-number> -->
                                <div style="display: flex">
                                    <!-- <el-input size="mini" type="input" :maxlength="30" placeholder="请输入" v-model.trim="scope.row.realSettleMoney">
                                </el-input> -->
                                    <el-input-number size="mini" :min="0" :max="scope.row.realSettleMoney"
                                        :precision="2" :controls="false" placeholder="请输入"
                                        v-model.trim="scope.row.actualSettleMoney">
                                    </el-input-number>
                                </div>
                            </template>
                        </el-table-column>

                        <!-- 结算日期 -->
                        <el-table-column prop="settleDate" label="结算日期" header-align="center" align="right"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.settleDate | getDate }}</span>
                            </template>
                        </el-table-column>

                        <!-- 供应商 -->
                        <el-table-column prop="levyCompanyName" label="供应商" header-align="center" align="right"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :style="scope.row.unPayMoney != 0 ? 'color:red' : ''">{{ scope.row.levyCompanyName
                                    }}</span>
                            </template>
                        </el-table-column>
                        <!-- 备注(含本次下发) -->
                        <!-- <el-table-column prop="memo" min-width="96" label="备注(含本次下发)" header-align="center" show-overflow-tooltip>
                        </el-table-column> -->
                        <el-table-column label="操作" header-align="center" width="60" align="center" fixed="right">
                            <template slot-scope="scope">
                                <a class="txt-color" @click="delItem( scope.row,scope.$index)">删除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- end of 单据明细 -->
            <!-- start of 付款方明细信息 -->
            <div class="back-color-fff mt-4 pd-16">
                <span class="form-title">贵方银行账号信息</span>
                <div class="content-main-box detail-box">
                    <el-table stripe border ref="multipleTable" :data="settlePaymentBankInfo">
                        <!-- 开户名称 -->
                        <el-table-column show-overflow-tooltip label="开户名称" width="210" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.tenantName || '-' }}
                            </template>
                        </el-table-column>
                        <!-- 开户银行 -->
                        <el-table-column label="开户银行" width="220" header-align="center" align="left">
                            <template slot-scope="scope">
                                <div style="padding:4px 0;">
                                    <el-select style="width:200px;" size="mini" @change="bankPayChange" filterable
                                        clearable v-model="scope.row.bankGuid" placeholder="请选择开户银行">
                                        <el-option v-for="item in scope.row.bankList" :key="item.guid"
                                            :label="item.bankName" :value="item.guid">
                                            <span style="float: left">{{
                                                `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType,'账户类型')}`
                                                }}</span>
                                        </el-option>
                                    </el-select>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 银行账户 -->
                        <el-table-column show-overflow-tooltip label="银行账户" width="220" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.bankAccount || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="税号" width="180" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.taxNo || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="电话" width="110" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.tel || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="付款地址" header-align="center" align="left">
                            <template slot-scope="scope">
                                {{ scope.row.address || '-' }}
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>
            <!-- end of 付款方明细信息 -->
            <!-- start of 收款方明细信息 -->
            <div class="back-color-fff mt-4 pd-16">
                <span class="form-title">我方银行账号信息</span>
                <div class="content-main-box detail-box">
                    <el-table stripe border ref="multipleTable3" row-key="bankAccount" :data="settleReceiveBankInfo">
                        <el-table-column type="expand" width="20">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="table-expand">
                                    <el-form-item label="备注">
                                        <el-input size='mini' v-model="props.row.memo" placeholder="请输入备注"></el-input>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                        <!-- 开户名称 -->
                        <el-table-column show-overflow-tooltip label="开户名称" width="210" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.tenantName || '-' }}
                            </template>
                        </el-table-column>
                        <!-- 开户银行 -->
                        <el-table-column label="开户银行" width="220" header-align="center" align="left">
                            <template slot-scope="scope">
                                <div style="padding:4px 0;">
                                    <el-select style="width:200px;" size="mini" @change="bankReciveChange(scope)"
                                        filterable clearable v-model="scope.row.bankGuid" placeholder="请选择开户银行">
                                        <el-option v-for="item in scope.row.bankList" :key="item.guid"
                                            :label="item.bankName" :value="item.guid">
                                            <span style="float: left">{{
                                                `${item.bankName}_${item.bankAccount}_${$getNameByKey(item.accountType,'账户类型')}`
                                                }}</span>
                                        </el-option>
                                    </el-select>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 银行账户 -->
                        <el-table-column show-overflow-tooltip label="银行账户" width="220" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.bankAccount || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="税号" width="180" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.taxNo || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="电话" width="110" header-align="center"
                            align="left">
                            <template slot-scope="scope">
                                {{ scope.row.tel || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="付款地址" header-align="center" align="left">
                            <template slot-scope="scope">
                                {{ scope.row.address || '-' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- end of 收款方明细信息 -->

            <!-- start of 流程审批 -->
            <div class="back-color-fff mt-4 pd-16">
                <!-- <span class="form-title">流程审批</span> -->
                <div class="flow">
                    <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
                </div>
            </div>
            <!-- end of 流程审批 -->

            <!-- start of bottom-btn -->
            <div class="back-color-fff submit_btn_wrap">
                <el-button type="defalut" class="cannel-btn" size="mini" @click="$router.go(-1)">取消</el-button>
                <el-button type="defalut" size="mini" @click="submitForm(false)">保存</el-button>
                <!-- <el-button type="primary" size="mini" @click="submitForm(true)">提交申请</el-button> -->
            </div>
            <!-- end of bottom-btn -->
        </div>
        <!-- end of form -->

        <!-- start of dialog-关联流程 -->
        <el-dialog title="质量考核" class="flow-dialog" :visible.sync="dialogFormVisible" width="80%">
            <div class="content-main-box content-main-box2">
                <div class="search-area">
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <div class="search-area-div w80">关键字搜索</div>
                            <el-input v-model="page.searchKey" placeholder="请输入企业、组织、应付金额搜索" size="mini"
                                class="ipt-sty">
                            </el-input>
                        </el-col>
                        <el-col :span="8">
                            <div class="search-area-div w60">关联状态</div>
                            <el-select filterable clearable v-model="page.isDownStreamUsed" placeholder="请选择关联状态"
                                size="mini" class="ipt-sty">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已关联" value="Y"></el-option>
                                <el-option label="未关联" value="N"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8" class="search-btn-box">
                            <el-button size="mini" type="info" @click="getFlowList(true)">搜索</el-button>
                            <el-button size="mini" type="danger" @click="empty">清空</el-button>
                        </el-col>
                    </el-row>
                </div>

                <el-table stripe border ref="multipleTable1" :max-height="420" highlight-current-row :data="flowLists"
                    :row-key="(row) => row.guid" :current-row-key="currentRowKey" @row-click="flowListsChange"
                    @select="handleSelectFlow" :header-cell-class-name="cellClass">
                    <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
                    <!-- 流程名称 -->
                    <!-- <el-table-column prop="flowName" min-width="120" label="流程名称" header-align="center" align="left" show-overflow-tooltip>
                    </el-table-column> -->
                    <!-- 发起人 -->
                    <el-table-column prop="staffName" width="100" label="发起人" header-align="center" align="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <!-- 流程编号 -->
                    <el-table-column prop="flowNo" width="120" label="流程编号" header-align="center" align="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <!-- 药企名称 -->
                    <el-table-column prop="tenantName" label="企业名称" header-align="center" align="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <!-- 组织名称 -->
                    <el-table-column prop="organisationName" width="180" label="组织名称" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.organisationName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 核算月 -->
                    <el-table-column prop="accountMonth" width="96" label="核算月" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.accountMonth || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 账单期数 -->
                    <el-table-column prop="billCycle" width="96" label="账单期数" header-align="center" align="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <!-- 应付金额 -->
                    <el-table-column prop="totalMoney" width="140" label="考核金额(元)" header-align="center" align="right"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.totalMoney | numDigit }}</template>
                    </el-table-column>
                    <el-table-column prop="createTime" width="140" label="提交时间" header-align="center" align="right"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.createTime | getTime }}</template>
                    </el-table-column>
                </el-table>

                <!-- start of pagination -->
                <!-- <el-pagination
                    class="pt pb back-color-fff"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="page.pageIndex"
                    :page-size="page.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.totalRows"
                >
                </el-pagination> -->
                <!-- end of pagination -->
            </div>
            <div slot="footer">
                <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
                <el-button size="mini" type="info" @click="selectProcess()">确定</el-button>
            </div>
        </el-dialog>
        <!-- end of dialog-关联流程 -->

        <!-- start of dialog-关联金额对冲流程 -->
        <el-dialog title="金额对冲" class="flow-dialog" :visible.sync="dialogHedgeVisible" width="80%">
            <div class="content-main-box content-main-box2">
                <div class="search-area">
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <div class="search-area-div w80">关键字搜索</div>
                            <el-input v-model="pageHedge.searchKey" placeholder="请输入企业、组织、应付金额搜索" size="mini"
                                class="ipt-sty">
                            </el-input>
                        </el-col>
                        <!-- <el-col :span="8">
                            <div class="search-area-div w60">关联状态</div>
                            <el-select filterable clearable v-model="pageHedge.isSettleUsed" placeholder="请选择关联状态"
                                size="mini" class="ipt-sty">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已关联" value="Y"></el-option>
                                <el-option label="未关联" value="N"></el-option>
                            </el-select>
                        </el-col> -->
                        <el-col :span="8" class="search-btn-box">
                            <el-button size="mini" type="info" @click="getHedgeList()">搜索</el-button>
                            <el-button size="mini" type="danger" @click="emptyHedge">清空</el-button>
                        </el-col>
                    </el-row>
                </div>

                <el-table stripe border ref="multipleTable2" highlight-current-row :data="hedgeLists"
                    :row-key="(row) => row.guid" @row-click="hedgeListsChange" @select="handlehedgeSelectFlow"
                    :header-cell-class-name="cellClass">
                    <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
                    <!-- 流程名称 -->
                    <el-table-column prop="flowName" min-width="120" label="流程名称" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.approveVO.flowName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 发起人 -->
                    <el-table-column prop="staffName" label="发起人" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.approveVO.staffName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 药企名称 -->
                    <el-table-column prop="bizTenantName" label="药企名称" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.operationReportTenantName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 组织名称 -->
                    <el-table-column prop="organisationName" label="组织名称" header-align="center" align="left"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.organisationName || '-' }}
                        </template>
                    </el-table-column>
                    <!-- 核算月 -->
                    <el-table-column prop="accountMonthName" min-width="96" label="核算月" header-align="center"
                        align="left" show-overflow-tooltip>
                        <!-- <template slot-scope="scope">
                            {{ scope.row.accountMonth ? JSON.parse(scope.row.accountMonth).toString() :  '-'}}
                        </template> -->
                    </el-table-column>
                    <!-- 任务包名称 -->
                    <el-table-column prop="taskTitleName" min-width="120" label="任务包名称" header-align="center"
                        align="left" show-overflow-tooltip>
                    </el-table-column>
                    <!-- 已付款金额(元) -->
                    <el-table-column prop="paidAmount" min-width="96" label="累计已付款金额(元)" header-align="center"
                        align="right" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.paidAmount | numFmt | numDigit }}</template>
                    </el-table-column>
                    <el-table-column prop="returnedAmount" min-width="96" label="累计已退回金额(元)" header-align="center"
                        align="right" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.returnedAmount | numFmt | numDigit }}</template>
                    </el-table-column>
                </el-table>

                <!-- start of pagination -->
                <!-- <el-pagination
                    class="pt pb back-color-fff"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="page.pageIndex"
                    :page-size="page.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.totalRows"
                >
                </el-pagination> -->
                <!-- end of pagination -->
            </div>
            <div slot="footer">
                <el-button plain size="mini" @click="dialogHedgeVisible = false">取消</el-button>
                <el-button size="mini" type="info" @click="selectHedgeProcess()">确定</el-button>
            </div>
        </el-dialog>
        <!-- end of dialog-关联金额对冲流程 -->

        <!-- start of dialog-批量修改供应商 -->
        <el-dialog :title="'批量修改供应商'" :visible.sync="dialogBatchEdit" width="550px">
            <div class="initiate-box">
                <div>供应商：</div>
                <el-select style="width:400px" filterable clearable v-model="tenantGuid" placeholder="请选择供应商"
                    size="small" @change="changeTenantData">
                    <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
                    </el-option>
                </el-select>
            </div>
            <div slot="footer">
                <el-button plain size="mini" @click="dialogBatchEdit = false">取消</el-button>
                <el-button size="mini" type="info" @click="batchEditData()">确定</el-button>
            </div>
        </el-dialog>
        <!-- end of dialog-批量修改供应商 -->

        <!-- start of dialog-批量修改结算日期 -->
        <el-dialog :title="'批量修改结算日期'" :visible.sync="dialogBatchEditTime" width="550px">
            <div class="initiate-box">
                <div>结算日期：</div>
                <el-date-picker v-model="batchSettleDate" type="date" placeholder="选择结算日期" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div slot="footer">
                <el-button plain size="mini" @click="dialogBatchEditTime = false">取消</el-button>
                <el-button size="mini" type="info" @click="batchEditTimeConfirm()">确定</el-button>
            </div>
        </el-dialog>
        <!-- end of dialog-批量修改结算日期 -->
        <!-- 批量删除时选择人员弹框 -->

        <el-dialog title="选择部门/人员" :visible.sync="visible3" :close-on-click-modal="false" width="60%" center
            v-loading="tableLoading">
            <div>
                <div class="select-box">
                    <div class="box-left fl">
                        <el-input v-model="filterText2" class="mt15" placeholder="请输入部门/人员名称"></el-input>
                        <el-tree class="filter-tree mt10" :data="areaData" :props="defaultProps" :show-checkbox="true"
                            node-key="guid" :filter-node-method="filterNodeDep" @node-click="handleNodeClick1"
                            ref="treeDep" @check-change="checkChange">
                            <div class="custom-tree-node" slot-scope="{ node, data }">
                                <img v-if="data.nodeType == 1" src="@/assets/images/ico_ora.png" alt="" />
                                <img v-else src="@/assets/images/icon_per.png" alt="" />
                                <span>{{ data.name }}</span>
                            </div>
                        </el-tree>
                    </div>
                    <div class="box-right fr">
                        <p class="fontC-bbb fl">已选{{ departmentList.length }}人</p>
                        <el-button size="mini" type="danger" @click="delDepartment()" class="fr"
                            style="margin-top: 5px">批量删除
                        </el-button>
                        <el-table :data="departmentList" border height="280px" style="width: 100%"
                            @selection-change="handleSelectionChange1">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column header-align="center" align="center" show-overflow-tooltip prop="name"
                                label="名称">
                                <template slot-scope="scope">
                                    {{ scope.row.name }}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer t-right">
                <el-button plain size="mini" @click="visible3 = false">取消</el-button>
                <el-button size="mini" type="info" @click="submitDepartment()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import { bpmnroute } from '@/api/apiRoute';
import qs from 'qs';
import cloneDeep from 'lodash/cloneDeep';
import getTenantDetail from '../../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../../mixins/getTenantDetail'
export default {
    mixins: [getTenantDetail],
    data() {
      return {
          ServiceProviderTypeEnum,
          serviceTenantList:[],
          operateReportGuid:null,
          pickerOptions: {
              disabledDate(time) {
                  return time.getTime() < Date.now() - 8.64e7;
              }
          },
          fullscreenLoading: false,
          guid: '',
          formData: {
              relevance: '', // 关联流程
              settleDate: '', // 结算日期
              isStampApply: '', // 申请盖章
              relevanceHedge:'', // 金额对冲流程关联显示内容
              servicerGuid:'',//关联服务商
              servicerName:''
          },
          formRules: {
              relevance: [
                  { required: true, message: '关联流程必填' }
              ],
              settleDate: [
                  { required: true, message: '结算日期必填', trigger: 'change' }
              ],
              isStampApply: [
                  { required: true, message: '申请盖章必填', trigger: 'change' }
              ],
          },
          multipleSelection: [],
          tableData: [],
          tableHeight: '50vh',

          // 单据明细相关
          dialogBatchEdit: false,
          tenantList: [], // 供应商下拉选数据
          tenantGuid: '', // 供应商
          tenantName: '', // 名称供应商
          selectData: [],
          batchSettleDate:'',// 批量修改的结算日期
          // 关联流程相关
          dialogFormVisible: false,
          dialogHedgeVisible: false,
          dialogBatchEditTime:false,
          page: {
              "approveState": "Y",
              "searchKey": "",
              "isDownStreamUsed": "N",
              "pageIndex": 1,
              "pageSize": -1
          },
          pageHedge:{
              "pageIndex": 1,
              "pageSize": -1,
              "searchKey": "",
              "isSettleUsed":"N",
              "serviceTenantGuid":localStorage.guid,
          },
          flowLists: [],
          hedgeLists: [], // 对冲金额流程

          // 流程图相关
          iframeSh: false,
          iframeSrc: '',

          currentRow: '',
          currentRowKey: null,
          currentHedgeRow: '',
          currentHedgeRowKey: null,
          detailData: '', // 详情数据
          settlePaymentBankInfo: [],//付款方银行信息
          settleReceiveBankInfo: [],//收款方信息
          /**当前收款方银行 错误信息 */
          currBanksByRelMsg: '',
          haveHedge:true, // 是否有对冲流程
          visible3: false,
          tableLoading:false,
          filterText2: "",
          qualityTenantGuid:'',//关联质量考核的企业guid
          areaData:[],
          defaultProps: {
            id: 'guid',
            label: 'name',
            children: 'children',
          },
          departmentList:[],//已选的人员
          delList:[],//删除人员的勾选
      };
    },
    created() {
        this.getTenantList();
        this.getServiceTenantList();
        this.getFlowList();
        if (this.$route.query.guid) {
            this.guid = this.$route.query.guid;
            this.getDetailData()
        } else {
            let userInfo = JSON.parse(localStorage.userInfo);
            this.formData.servicerGuid = localStorage.guid;
            this.formData.servicerName = userInfo.tenantName;
        }
        this.getApprovalList();
        this.Mixins_getServiceProviderType();
    },
    watch: {
      filterText2(val) {
        this.$refs.treeDep.filter(val);
      },
    },
    computed: {
        isThirdPartyContractor() {
            try {
                // 可以直接访问到 mixins 中的 data 变量
                const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
                return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
            } catch (error) {
                console.log(error);
            }
        },
    },
    methods: {
      delItem(row,idx){
          this.$confirm('是否删除该条数据?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.tableData.splice(idx,1);
          });
          
      },
        //获取服务商
    getServiceTenantList() {
        let self = this;
        self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.serviceTenantList = res.data.data || [];
            } else {
                self.$message.error(res.data.msg);
            }
        });
    },
    tenantChange(val) {
        this.serviceTenantList.forEach(i=>{
            if(i.guid == val ){
                this.formData.servicerName = i.tenantName;
            }
        })
        this.getGgenerateDetail();
    },
      //批量删除修改
    batchDel(){
        let self = this;
        self.filterText2=''
        self.visible3 = true;
        self.departmentList = [];
        self.delList = [];
        self.$nextTick(() => {
          self.$refs.treeDep.setCheckedNodes(self.departmentList);
        });
      },
      //获取组织
      getOrganisation() {
        let self = this;
        let staffGuidList = [...new Set(this.tableData.map(item => item.staffGuid))];
        let query = {
          tenantGuid: this.qualityTenantGuid,
          staffGuidList,
        };
        self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/tree-staff-base`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            self.batchDel()
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
          this.$forceUpdate()
        });
      },
      getSumAmount(list, type) {
          let sum = 0;
          if (type == 1) {
              list.forEach(item => {
                  // sum += item.settleAmount;
                  sum += Math.round(item.settleAmount * 100) / 100 ;
              })
          }
          if (type == 2) {
              list.forEach(item => {
                  // sum += item.realSettleMoney;
                  sum += Math.round(item.realSettleMoney * 100) / 100 ;
              })

          }
          if (type == 3) {//实发
              list.forEach(item => {
                  sum += Math.round(item.actualSettleMoney * 100) / 100 ;
              })

          }
          return sum
      },
      checkChange(val) {
        // console.log(this.$refs.treeDep.getCheckedNodes());

        this.departmentList = [];
        let checkNodes = this.$refs.treeDep.getCheckedNodes();
        if (checkNodes.length > 0) {
          checkNodes.forEach((i) => {
            if (i.nodeType != 1) {
              this.departmentList.push(i);
            }
          });
        }
        // this.departmentList = this.$refs.treeDep.getCheckedNodes();
        console.log("checkChange", this.departmentList);
      },
      delDepartment() {
        let self = this;
        if (self.delList == null || self.delList.length == 0) {
          self.$message.error("请先勾选数据!");
          return;
        }
        self.delList.forEach(function (j) {
          self.departmentList.forEach(function (i, index) {
            if (i.guid == j.guid) {
              self.departmentList.splice(index, 1);
            }
          });
        });
        this.$refs.treeDep.setCheckedNodes(this.departmentList);
      },
      handleSelectionChange1(val) {
        let self = this;
        self.delList = val;
        console.log(val);
      },
      filterNodeDep(value, data) {
        console.log('77',value, data);
        
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      //部门弹框选择
      handleNodeClick1(data) {
        // let self = this;
        // console.log(data);
        // console.log(self.departmentList);
      },
      submitDepartment() {
        let self = this;
        if (!self.departmentList) {
          self.$message.error("请选择人员!");
          return;
        }
        let staffGuids = [];
        self.departmentList.forEach((i) => {
          staffGuids.push(i.guid);
          self.tableData=self.tableData.filter(item =>!staffGuids.includes(item.staffGuid));
          
        });
        self.visible3=false
        this.$forceUpdate()
      },
      cellClass(row) {
          if (row.columnIndex === 0) {
              return 'disabledCheck';
          }
      },
      /**
       * 获取详情
       */
      getDetailData() {
          let self = this;
          self.api.get(`/${serverConfig.msSalesPerformService}/downstream/settle/detail/${self.$route.query.guid}`).then((res) => {
              let { code, data, msg } = res.data;
              if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  this.detailData = data;
                  // this.currentRowKey = data.operationReportGuidList[0]; // !运营报告 guid v4.2.6-8版本停用
                  this.currentRowKey = data.qualityAssessmentGuidList? data.qualityAssessmentGuidList[0] : data.operationReportGuidList ? data.operationReportGuidList[0] : '' ; // !优先取质量考核报告, 如果没有则取运营报告
                  this.formData['settleDate'] = data.settleDate;
                  this.formData['isStampApply'] = data.isStampApply;
                  this.formData['servicerGuid'] = data.servicerGuid;
                  this.formData['servicerName'] = data.servicerName;
                  let accountMonth = data.accountMonth ? JSON.parse(data.accountMonth) : [];
                  // 显示发起人 + 药企简称 + 月份 + 应付金额
                  this.formData['relevance'] =  `${data['applyStaffName']} _ ${data['operationReportTenantName']} _ ${accountMonth.join(' , ')}${(data['currentPayAmount'] ? (' _ ' + this.formatMoney(data['currentPayAmount']) + '(元)') : '')}`
                  let settleDetailList = data.settleDetailList || [];
                  let arr = [];
                  settleDetailList.forEach((citem, cIndex) => {
                      citem.rowKey = index + '-' + cIndex;
                      arr.push(citem)
                  })
                  // 结算明细
                  this.tableData = arr;
                  this.getApprovalList();
                  this.getSettlePaymentBankInfo();
                  this.getSettleReceiveBankInfo(true);

                  // console.log(this.formData)
              } else {
                  self.$message.error(msg);
              }
          });
      },
      /**
       * 获取供应商接口
       */
      getTenantList() {
          let self = this;
          let postData = {
              'pageIndex': 1,
              'pageSize': -1,
              // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
              "enterpriseType": '9901,9902,9904,9905',
          }
          self.api.get(`/${serverConfig.msCustomerService}/delegation-company/list?${qs.stringify(postData)}`).then(res => {
              let { code, msg, data } = res.data;
              if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.tenantList = data.records || [];
              } else {
                  self.$message.error(msg);
              }
          });
      },
      /**
       * 选择流程
       */
      focusRelevance() {
          let that = this;
          if (that.flowLists.length == 0) {
              return that.getFlowList(false, function () {
                  that.dialogFormVisible = true;
              });
          }
          that.dialogFormVisible = true;
      },
      /**
       * 获得金额对冲流程
       */
      showHedgeList() {
          if (this.hedgeLists.length == 0) {
              this.getHedgeList(()=> {
                  this.dialogHedgeVisible = true;
              });
          }
          this.dialogHedgeVisible = true;
      },
      getHedgeList(callback) {
        let param = {
            ...this.pageHedge,
            flowTypeList:['00025'],
            listType:1,
            approveState:'Y',
            excludeOperateReportTenantGuid:this.currentRow.bizTenantGuid || '',
            excludeSettleLeveyGuids:this.excludeSettleLeveyGuids,
            staffGuid:JSON.parse(localStorage.userInfo).staffGuid,
            operateReportGuid:this.operateReportGuid
        }
        this.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/page-list`, param).then((res) => {
            let { code, data } = res.data;
            if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.hedgeLists = (data && data.records) ? data.records : [];
                this.hedgeLists.forEach(item => {
                    let accountMonth = JSON.parse(item.accountMonth) || [];
                    item.accountMonthName = accountMonth.join(',');
                });
                if (callback) callback();
            } else {
                this.$message.error(res.data.msg);
            }
        });
      },
      /**
       * 提交
       */
      submitForm(flag) {
          if(this.tableData.length<1){
              this.$message.error('单据明细不能为空，不可提交！');
              return
          }
          this.postFormData(flag);
      },
      postFormData(flag) {
          let self = this;
          if (!this.checkForm()) return;
          if (this.currBanksByRelMsg) {
            // 接口返回的错误信息 不允许提交
            this.$message.error(this.currBanksByRelMsg);
            return;
          }
          let postData = JSON.parse(JSON.stringify(this.formData));
          let userInfo = JSON.parse(localStorage.userInfo);
          // postData['operationReportGuidList'] = [this.currentRowKey]; // !运营报告 guid v4.2.6-8版本停用
          postData['qualityAssessmentGuidList'] = [this.currentRowKey]; // !质量考核 guid
          postData['settleDetails'] = this.tableData;
          postData['serviceTenantGuid'] = localStorage.guid;
          postData['serviceTenantName'] = userInfo['tenantName'];
          postData['applyStaffGuid'] = userInfo['staffGuid'];
          postData['applyStaffName'] = userInfo['staffName'];
          postData['immediateSubmit'] = flag; // false是保存 true是保存并提交
          postData['settlePaymentBankInfo'] = this.settlePaymentBankInfo[0]
          postData['settleReceiveBankInfo'] = this.settleReceiveBankInfo
          postData['settleHedgeGuid'] = this.currentHedgeRowKey // !结算金额对冲流程唯一标识
          let url = 'downstream/settle/add';
          if (this.$route.query.guid) {
              url = 'downstream/settle/update';
              postData['guid'] = this.$route.query.guid;
              postData['guidResubmit'] = this.$route.query.type == 2 ? this.$route.query.guid : null;
          }
          this.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/${url}`, postData).then((res) => {
              // this.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  if (flag) {
                      self.$message.success('提交成功！');
                  } else {
                      self.$message.success('保存成功！');
                  }
                  self.$router.go(-1);
              } else {
                  this.fullscreenLoading = false;
                  self.$message.error(res.data.msg);
              }
          });
      },
      checkForm() {
          if (!this.formData.relevance) {
              this.$message.error('关联流程不能为空')
              return false;
          }
        if (!this.formData.servicerGuid) {
              this.$message.error('关联服务商不能为空')
              return false;
          }
          if (!this.formData.settleDate) {
              this.$message.error('结算日期不能为空')
              return false;
          }
          if (!this.formData.isStampApply) {
              this.$message.error('盖章申请不能为空')
              return false;
          }
          try {
              this.tableData.forEach(item => {
                  if (!item.levyCompanyGuid) {
                      throw new Error('供应商不能为空，请批量调整')
                  }
              })
              this.settlePaymentBankInfo.forEach(item => {
                  if (!item.bankName) {
                      throw new Error('请完善贵方银行账号信息')
                  }
              })
              this.settleReceiveBankInfo.forEach(item => {
                  if (!item.bankName) {
                      throw new Error('请完善我方银行账号信息')
                  }
              })
          } catch (e) {
              this.$message.error(e.message);
              return false;
          }


          return true;
      },
      changeTenantData() {
          let tenantList = this.tenantList;
          tenantList.forEach(item => {
              if (item.guid == this.tenantGuid) {
                  this.tenantName = item.tenantName;
              }
          })
      },
      /**
       * 批量修改
       */
      batchEdit() {
          if (this.selectData.length == 0) {
              return this.$message.error('请先勾选数据');
          }
          this.dialogBatchEdit = true;
          this.tenantGuid = ''; // 供应商
          this.tenantName = ''; // 供应商
      },
      /**
       * 批量修改结算日期
       */
      batchEditTime() {
          if (this.selectData.length == 0) {
              return this.$message.error('请先勾选数据');
          }
          this.dialogBatchEditTime = true;
          this.batchSettleDate = ''; // 批量修改的结算日期
      },
      /**
       * 批量修改结算日期确认
       */
      batchEditTimeConfirm() {
          let { selectData, tableData } = this;
          selectData.forEach(item => {
              tableData.forEach(citem => {
                  if (item.rowKey == citem.rowKey) {
                      citem.settleDate = this.batchSettleDate;
                  }
              })
          })
          this.tableData = JSON.parse(JSON.stringify(tableData));
          this.dialogBatchEditTime = false;
      },
      /**
       * 确定批量修改
       */
      batchEditData() {
          let { selectData, tableData } = this;
          selectData.forEach(item => {
              tableData.forEach(citem => {
                  if (item.rowKey == citem.rowKey) {
                      citem.levyCompanyName = this.tenantName;
                      citem.levyCompanyGuid = this.tenantGuid;
                  }
              })
          })
          this.tableData = JSON.parse(JSON.stringify(tableData));
          this.getSettleReceiveBankInfo();
          this.dialogBatchEdit = false;
    this.checkHedge(this.tableData) // todo 判断运营报告和代征公司是否有对冲流程
      },
      /**
       * 勾选数据
       */
      handleSelectionChange(val) {
          console.log(val)
          this.selectData = val || [];
      },
      /**
       * 修改结算日期
       */
      changeSettleDate() {
          if (this.currentRowKey) {
              this.getGgenerateDetail();
          }
      },
      /**
       * 选择质量考核流程
       */
      selectProcess() {
          let { currentRow } = this;
          // console.log(currentRow)
          // 关联流程后显示发起人 + 药企简称 + 月份 + 应付金额
          if (!currentRow['guid']) return this.$message.error('请关联流程');
          //运营报告唯一guid
          this.qualityTenantGuid = currentRow['tenantGuid'];
          this.operateReportGuid = currentRow['guid'];
          this.formData.relevance = currentRow['staffName'] + ' _ ' + currentRow['tenantName'] + ' _ ' + currentRow['accountMonth'] + (currentRow['totalMoney'] ? (' _ ' + this.formatMoney(currentRow['totalMoney']) + '(元)') : '');
          this.dialogFormVisible = false;
          this.clearHedge() // 清空关联的金额对冲流程
          console.log('this.formData',this.formData,currentRow);
          
          // 获取单据明细
          if (this.formData['settleDate']) {
              this.getGgenerateDetail();
          }
      },
      /**
       * 选择金额对冲流程
       */
      selectHedgeProcess() {
        let { currentHedgeRow } = this;
        let { approveVO } = currentHedgeRow
        let paidAmount = currentHedgeRow.paidAmount !==null ? `${this.formatMoney(currentHedgeRow.paidAmount)}(元)` : ''
        let returnedAmount = currentHedgeRow.returnedAmount !==null ? `${this.formatMoney(currentHedgeRow.returnedAmount)}(元)` : ''
          // 关联流程后显示发起人 + 药企简称 + 月份 + 应付金额
        if (!approveVO['staffName']) return this.$message.error('请关联流程');
        this.formData.relevanceHedge = approveVO['staffName'] + ' _ ' + currentHedgeRow['operationReportTenantName'] +' _ ' + currentHedgeRow['accountMonthName'] +' _ ' + paidAmount + returnedAmount
        this.dialogHedgeVisible = false;
      },
      // 清空关联的金额对冲流程
      clearHedge() {
        this.currentHedgeRow = ''
        this.currentHedgeRowKey = ''
        this.formData.relevanceHedge = ''
        if (this.$refs.multipleTable2) this.$refs.multipleTable2.clearSelection();
      },
      /**
       * 获取单据明细
       */
      getGgenerateDetail() {
          this.tableData = [];
          let userInfo = JSON.parse(localStorage.userInfo);
          if(!this.formData['settleDate']) return;
          let postData = {
              serviceTenantGuid: localStorage.guid,
              serviceTenantName: userInfo['tenantName'],
              // operationReportGuidList: [this.currentRowKey], // !运营报告 guid v4.2.6-8版本停用
              qualityAssessmentGuidList: [this.currentRowKey], // !质量考核 guid
              applyStaffGuid: userInfo['userGuid'],
              applyStaffName: userInfo['staffName'],
              settleDate: this.formData['settleDate'],
          }
          this.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/generate-detail`, postData).then((res) => {
              let { code, data } = res.data;
              if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  let datas = data || [];
                  datas.forEach((item, index) => {
                      item.rowKey = index;
                  })
                  this.tableData = datas;
                  
                  this.getSettlePaymentBankInfo();
                  this.getSettleReceiveBankInfo();
                  this.checkHedge(this.tableData)
                //   this.getOrganisation()

              } else {
                  this.$message.error(res.data.msg);
              }
          });
      },
      /**
       * 获取付款方银行信息
       */
      getSettlePaymentBankInfo() {
        //   console.log(this.tableData)
        //   let userInfo = JSON.parse(localStorage.userInfo)
          if (!this.formData.servicerGuid) return;
          let req = {
              "tenantGuids": [this.formData.servicerGuid]
          }
          this.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-banks`, req).then((res) => {
              let { code, data } = res.data;
              if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  if (this.$route.query.guid) {
                      //编辑
                      let bankGuid = null;
                      if (data.length && data[0].bankList) {
                          data[0].bankList.forEach(item => {
                              if (item.bankAccount == this.detailData.serviceTenantContractBank.bankAccount) {
                                  bankGuid = item.guid;
                              }
                          })
                      }
                      this.settlePaymentBankInfo = [{
                          'tenantGuid': this.formData.servicerGuid,
                          'tenantName':this.formData.servicerName,
                          'bankGuid': bankGuid,
                          'bankName': this.detailData.serviceTenantContractBank.bankName,
                          'bankAccount': this.detailData.serviceTenantContractBank.bankAccount,
                          'taxNo': this.detailData.serviceTenantContractBank.bankTaxNo,
                          'tel': this.detailData.serviceTenantContractBank.tel,
                          'address': this.detailData.serviceTenantContractBank.address,
                          'bankList': data[0].bankList
                      }]

                  } else {
                      //新增
                      this.settlePaymentBankInfo = [{
                          'tenantGuid':  this.formData.servicerGuid,
                          'tenantName': this.formData.servicerName,
                          'bankName': null,
                          'bankAccount': null,
                          'bankGuid': null,
                          'taxNo': data[0].taxpayerId,
                          'tel': data[0].tel,
                          'address': data[0].address,
                          'bankList': data[0].bankList
                      }]
                  }

              } else {
                  this.$message.error(res.data.msg);
              }
          });
      },
      bankPayChange(val) {
          let bankList = this.settlePaymentBankInfo[0].bankList;
          if (!val) {
              this.settlePaymentBankInfo = [{
                  'tenantGuid': this.settlePaymentBankInfo[0].tenantGuid,
                  'tenantName': this.settlePaymentBankInfo[0].tenantName,
                  'bankName': null,
                  'bankGuid': null,
                  'bankAccount': null,
                  'taxNo': this.settlePaymentBankInfo[0].taxNo,
                  'tel': this.settlePaymentBankInfo[0].tel,
                  'address': this.settlePaymentBankInfo[0].address,
                  'bankList': this.settlePaymentBankInfo[0].bankList,
              }]
          }
          bankList.forEach(item => {
              if (item.guid == val) {
                  this.settlePaymentBankInfo = [{
                      'tenantGuid': this.settlePaymentBankInfo[0].tenantGuid,
                      'tenantName': this.settlePaymentBankInfo[0].tenantName,
                      'bankName': item.bankName,
                      'bankGuid': item.guid,
                      'bankAccount': item.bankAccount,
                      'taxNo': this.settlePaymentBankInfo[0].taxNo,
                      'tel': this.settlePaymentBankInfo[0].tel,
                      'address': this.settlePaymentBankInfo[0].address,
                      'bankList': this.settlePaymentBankInfo[0].bankList,
                  }]
              }
          })
      },
      async getSettleReceiveBankList() {
            if (!this.settleReceiveBankInfo.length) return;
            const req = {
                tenantGuids: [this.settleReceiveBankInfo[0].tenantGuid],
            };
            const { data } = await this.api.postJson(
                `/${serverConfig.msCustomerService}/tenant/data/get-banks`,
                req
            );
            if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
                this.$message.error(data.msg);
                return;
            }
            if (!data.data?.length) {
                return;
            }
            this.settleReceiveBankInfo = this.settleReceiveBankInfo.map((item) => {
                return {
                ...item,
                bankList: data.data[0]?.bankList || [],
                };
            });
        },
      /**
       * 获取收款方银行信息
       * */
      getSettleReceiveBankInfo(flg) {
          let tenantGuids = [];
          this.tableData.forEach(item => {
              if (item.levyCompanyGuid) {
                  tenantGuids.push({
                      tenantGuid: item.levyCompanyGuid,
                      tenantName: item.levyCompanyName
                  });
              }
          })
          //去重
          const map = new Map();
          tenantGuids = tenantGuids.filter(v => !map.has(v.tenantGuid) && map.set(v.tenantGuid, 1));
          let count = tenantGuids.length;
          console.log(tenantGuids)
          if (!count||!this.formData.servicerGuid) return;
          let list = [];
          this.settleReceiveBankInfo = [];
          tenantGuids.forEach(item => {
              let query = {
                  serviceTenantGuid:this.formData.servicerGuid,
                  tenantGuid: item.tenantGuid
              }
              this.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-banks-by-rel`, query).then((res) => {
                  if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                      this.currBanksByRelMsg = '';
                      count--;
                      if (!res.data.data[0].bankList) {
                          this.$message.error('请先去维护' + item.tenantName + '银行信息！');
                      }
                      list = list.concat(res.data.data)
                      if (count) return;
                      console.log(list);
                      if (flg) {
                          //编辑
                          let bankGuid = null;
                          if (list.length && list[0].bankList) {
                              list[0].bankList.forEach(item => {
                                  if (item.bankAccount == this.detailData.tenantContractBank.bankAccount) {
                                      bankGuid = item.guid;
                                  }
                              })
                          }
                          this.settleReceiveBankInfo.push({
                              'tenantGuid': list[0].guid,
                              'tenantName': this.detailData.tenantContractBank.tenantName,
                              'bankGuid': bankGuid,
                              'bankName': this.detailData.tenantContractBank.bankName,
                              'bankAccount': this.detailData.tenantContractBank.bankAccount,
                              'taxNo': this.detailData.tenantContractBank.bankTaxNo,
                              'tel': this.detailData.tenantContractBank.tel,
                              'address': this.detailData.tenantContractBank.address,
                              'bankList': list[0].bankList
                          })
                      } else {
                          //新增
                          list.forEach(item => {
                              this.settleReceiveBankInfo.push({
                                  'tenantGuid': item.guid,
                                  'tenantName': item.tenantName,
                                  'bankName': null,
                                  'bankGuid': null,
                                  'bankAccount': null,
                                  'taxNo': item.taxpayerId,
                                  'tel': item.tel,
                                  'address': item.address,
                                  'bankList': item.bankList,
                              })
                          })

                      }

                      this.$nextTick(()=>{
                        this.toggleRowAll()
                        // this.getSettleReceiveBankList();
                      })
                  } else {
                      this.currBanksByRelMsg = res.data.msg
                      this.$message.error(res.data.msg);
                  }
              })

          })

          // console.log(list);
          // let req = {
          //     "tenantGuids": tenantGuids
          // }


          // this.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-banks`, req).then((res) => {
          //     let { code, data } = res.data;
          //     if (code == serverConfig.REQUIRE_SUCCESS_CODE) {

          //     } else {
          //         this.$message.error(res.data.msg);
          //     }
          // });
      },

      bankReciveChange(data) {
          console.log(data)
          let index = data.$index;
          let bankList = data.row.bankList;
          bankList.forEach(item => {
              if (item.guid == data.row.bankGuid) {
                  this.settleReceiveBankInfo[index].bankAccount = item.bankAccount;
                  this.settleReceiveBankInfo[index].bankName = item.bankName;
              }
          })
      },
      /**
       * 获取关联流程列表数据
       */
      getFlowList(flag = false, callback) {
          if (flag) {
              this.page.pageIndex = 1;
              this.flowLists = [];
          }
          let postData = {
              ...this.page,
              approveState:'Y',
              listType:1,
              staffGuid:JSON.parse(localStorage.userInfo).staffGuid
          }
          this.api.postJson(`/${serverConfig.msSalesPerformService}/quality-assessment/data/get-list`, postData).then((res) => {
              let { code, data } = res.data;
              if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  this.flowLists = (data && data.records) ? data.records : [];
                  // console.log(this.flowLists)
                  if (callback) callback();
              } else {
                  this.$message.error(res.data.msg);
              }
          });
      },
      /**
       * 清空条件搜索,重新获取流程列表数据
       */
      empty() {
          this.page = {
              "approveState": "Y",
              "flowType": "00016", // 
              "searchKey": "",
              "isDownStreamUsed": "",
              "pageIndex": 1,
              "pageSize": -1
          };
          this.getFlowList();
      },
      /**
       * 清空条件搜索,重新获取流程列表数据
       */
      emptyHedge() {
          this.pageHedge = {
            "pageIndex": 1,
            "pageSize": -1,
            "pageHedge": "",
            "searchKey": "",
            "serviceTenantGuid":localStorage.guid,
          }
          this.gethedgeList();
      },
      /**
       * 关联流程，查看详情
       */
      see() {

      },
      /**
       * 勾选关联流程数据
       */
      flowListsChange(row) {
          this.$refs.multipleTable1.clearSelection();
          row.flag = !row.flag;
          this.$refs.multipleTable1.toggleRowSelection(row, row.flag);
          this.currentRowKey = row.guid;
          this.currentRow = row;
      },
      handleSelectFlow(selection, row) {
          this.$refs.multipleTable1.clearSelection();
          if (selection.length == 0) {
              return;
          }
          if (row) {
              this.currentRow = row;
              this.currentRowKey = row.guid;
              this.$refs.multipleTable1.toggleRowSelection(row, true);
          }
      },
      /**
       * 勾选关联流程数据
       */
      hedgeListsChange(row) {
          this.$refs.multipleTable2.clearSelection();
          row.flag = !row.flag;
          this.$refs.multipleTable2.toggleRowSelection(row, row.flag);
          this.currentHedgeRowKey = row.guid;
          this.currentHedgeRow = row;
      },
      handlehedgeSelectFlow(selection, row) {
          this.$refs.multipleTable2.clearSelection();
          if (selection.length == 0) {
              return;
          }
          if (row) {
              this.currentHedgeRow = row;
              this.currentHedgeRowKey = row.guid;
              this.$refs.multipleTable2.toggleRowSelection(row, true);
          }
      },
      /**
       * 获取流程
       */
      getApprovalList() {
          // 00021:结算单流程,00022:付款单流程
          let self = this;
          let userInfo = JSON.parse(localStorage.userInfo);

          let { approveVO } = this.detailData;
          if (this.guid && approveVO.camundaInstanceId && approveVO.camundaDeploymentId) {
              this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + approveVO.camundaInstanceId + '&camundaDeploymentId=' + approveVO.camundaDeploymentId + '&token=' + localStorage.token;
              this.iframeSh = true;
              this.$forceUpdate()
              return;
          }
          let req = {
              tenantGuid: localStorage.guid,
              flowType: '00021',
              staffGuid: userInfo.staffGuid,
          };
          self.api
              .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
              .then((res) => {
                  if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                      if (res.data.data) {
                          self.iframeSrc = bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
                          self.iframeSh = true;
                          // console.log(self.iframeSrc);
                          this.$forceUpdate()
                      } else {
                          self.$message.error('未获取到流程信息');
                      }
                  } else {
                      self.$message.error(res.data.msg);
                  }
              });
      },
      /**
       * 修改当前页的数量
       * @param {*} val 
       */
      handleSizeChange(val) {
          this.page.pageSize = val;
          this.getFlowList();
      },
      /**
       * 修改分页
       * @param {*} val 
       */
      handleCurrentChange(val) {
          this.page.pageIndex = val || 1;
          this.getFlowList();
      },
      formatMoney(num) {
          // 将数字转换为字符串并保留两位小数
          num = num.toFixed(2);

          // 将字符串按小数点分割成整数部分和小数部分
          var parts = num.toString().split(".");

          // 将整数部分每三位加一个逗号
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // 将整数部分和小数部分拼接起来
          return parts.join(".");
      },
      // todo 判断运营报告和代征公司是否有对冲流程
      checkHedge(tableData) {
        let tenantGuids = []
        tableData.forEach(item=>{
          if (item.levyCompanyGuid) tenantGuids.push(item.levyCompanyGuid)
        })
        if (!tenantGuids.length) {
          this.$message.warning('请选择供应商')
          return
        }
        let param = {
          "serviceTenantGuid": localStorage.guid,
          "operationReportGuid": this.currentRowKey, // !运营报告 guid v4.2.6-8版本停用
          // "qualityAssessmentGuid": this.currentRowKey, // !质量考核
          "tenantGuids": [
            ...tenantGuids
          ]
        }
        this.excludeSettleLeveyGuids = tenantGuids
        this.api.postJson(`/${serverConfig.msSalesPerformService}/downstream/settle/hedge/report-whether-hedge`,param).then(res=>{
            let { code, data } = res.data;
            if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.haveHedge = data
              this.clearHedge() // 清空关联的金额对冲流程
            }
        })
      },
      // todo 展开表格扩展
      toggleRowAll() {
        this.settleReceiveBankInfo.forEach(row=>{
          this.$refs.multipleTable3.toggleRowExpansion(row, true) // 全部展开
        })
      }
    },
};
</script> 
  
<style lang="less" scoped>
.flex-between {
    display: flex;
    justify-content: space-between;
}

.total-tip {
    text-align: right;
    margin: 0 0 16px 0;
}

.total-tip span {
    color: #FF5F1F;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
    display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
    content: '';
    text-align: center;
    line-height: 37px;
}

.content {
    padding: 0px;
    margin: 0px;

    .title-box {
        border-top: 1px solid #E5E5E5;
        background-color: #ffffff;
        padding: 8px 0px;
        position: relative;

        button {
            font-size: 12px;
            color: #212121;
            letter-spacing: 0;
            width: 60px;
            height: 26px;
            padding: 0px;
            border: 1px solid rgba(217, 217, 217, 1);
            border-radius: 2px;
            position: absolute;
            left: 16px;
            top: 6px;
        }

        span {
            text-align: center;
            font-size: 16px;
            font-weight: 400;
        }
    }

    .mt-4 {
        margin-top: 4px;
    }

    .pd-16 {
        padding-bottom: 16px;
    }

    .form-box {
        margin-top: 4px;
        text-align: left;

        .form-title {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            margin-left: 16px;
            font-weight: 500;
        }

        /deep/ .el-row {
            margin: 0px !important;
        }

        .el-form-item {
            margin-bottom: 8px;
        }

        .over-label /deep/ .el-form-item__label {
            line-height: 21px;
        }

        .el-input {
            width: 220px;
        }

        .age-are-box {
            display: flex;
            align-items: center;

            .el-select {
                width: 142px;
            }

            span {
                margin: 0px 8px;
            }
        }

        .bottom-btn-box {
            padding: 18px 0px;
            text-align: center;
            border-top: 1px solid #E5E5E5;

            .el-button--primary {
                color: #ffffff;
            }
        }
    }

    /deep/ .el-dialog__header {
        text-align: left;
        border-bottom: 1px solid #D9D9D9;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px;
    }

    /deep/ .el-dialog__footer {
        padding: 10px 20px;
        border-top: 1px solid #D9D9D9;
    }

    .content-main-box2 {
        height: 55vh;
        overflow-x: hidden;

        .search-area {
            padding: 16px 0px;
        }

        .el-table {
            border-left: 1px solid #D8D8D8;
            border-right: 1px solid #D8D8D8;
            border-bottom: 1px solid #D8D8D8;
        }
    }

    .flow {
        background: #fff;
        padding-left: 20px;
    }

    .iframe-sty {
        width: 100%;
        border: none;
        height: 600px;

    }

    .detail-box {
        height: auto;
    }

    .cannel-btn {
        border: 1px solid rgba(217, 217, 217, 1);
        border-radius: 2px;
        color: #212121;
    }

    .initiate-box {
        display: flex;
        align-items: center;
        padding: 26px 0px;

        .el-select {
            margin-left: 10px;
        }
    }
    .table-expand {
        padding-left: 10px;
    }
}

// .content-main-box .el-table{
//     border: 0 none;
// }
.search-area .el-col-8{
    justify-content: flex-start;
}
</style>
